import { createSlice } from "@reduxjs/toolkit";

const initialState = {

    products: []
};

const marketplaceSlice = createSlice({

    name: "marketplace",

    initialState,

    reducers: {

        setMarketplaceProducts: (

            state,
            action

        ) => {

            state.products =
                action.payload;
        }
    }
});

export const {

    setMarketplaceProducts

} = marketplaceSlice.actions;

export default marketplaceSlice.reducer;